export const useStyles = () => {
    return {
        container: { width: '100%', display: 'flex', flexDirection: 'column', gap: 2, marginTop: 1 },
        check: {
            '& .MuiFormControlLabel-label': {
                wordBreak: 'break-word',
                fontSize: '14px',
                textAlign: 'start'
            },
            '& .MuiCheckbox-root': {
                padding: 0,
                '& .MuiBox-root': {
                    height: '15px',
                    width: '15px',
                }
            }
        },
        list: {
            width: '50%',
        },
        pagination: {
          '& .MuiPaginationItem-root': {
            margin: '10px 0 0 0',
          },
        },
        btn: {
            justifyContent: 'end'
        },
        listContainer: {
            backgroundColor: 'blue.100',
            padding: 2
        }
    }
}